import { InfoPopupComponent } from './../modals/info-popup/info-popup.component';
import { AlertController, ModalController } from '@ionic/angular';
import { Directive, HostListener, Input } from '@angular/core';
import { Dialog } from '@capacitor/dialog';

@Directive({
  selector: '[infoText]',
})
export class InfoTextDirective {  
  @Input() infoTitle = '';
  @Input() infoText =
    'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.';
  @Input() infoLink = '';
  @Input() infoLinkTitle = '';
  @Input() defaultButton = 'OK';


  constructor(private modalController: ModalController, private alertController: AlertController) {}

  @HostListener('click') onClick() {
    //this.presentModal();
    //this.presentNativeDialog();
    this.presentIonicAlert();
  }

  async presentModal() {
    const modal = await this.modalController.create({
      component: InfoPopupComponent,
      componentProps: {
        title: this.infoTitle,
        content: this.infoText,
      },
    });
    return await modal.present();
  }

  async presentNativeDialog() {
    await Dialog.alert({
      title: this.infoTitle,
      message: this.infoText,
    });
  }

  async presentIonicAlert() {    
    const buttons:any[] = [this.defaultButton];
    if(this.infoLink && this.infoLinkTitle){
      buttons.unshift(
        {
          text: this.infoLinkTitle,
          handler: () => {
            window.open(this.infoLink, '_blank');
          }
        }
      );
    }    
    const alert = await this.alertController.create({
      header: this.infoTitle,
      //subHeader: 'Subtitle',
      message: this.infoText,
      buttons,
    });
    await alert.present();
  }
}
